const SENSITIVE_OIDC_USER_KEYS = ["access_token", "id_token", "refresh_token"];

const sanitizeStateForPersistence = (state) => {
  if (!state || !state.oidc || !state.oidc.user) {
    return state;
  }
  const sanitizedUser = { ...state.oidc.user };
  SENSITIVE_OIDC_USER_KEYS.forEach((key) => {
    delete sanitizedUser[key];
  });
  return {
    ...state,
    oidc: {
      ...state.oidc,
      user: sanitizedUser,
    },
  };
};

export const loadState = () => {
  try {
    const serializedState = localStorage.getItem("state");
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

export const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(sanitizeStateForPersistence(state));
    localStorage.setItem("state", serializedState);
  } catch (err) {
    //Log this error somewhere.
    console.log("Setting State in LocalStorage failed.");
    console.log(err);
  }
};
